import { envConfig } from '../../../env';
import { Post } from '@/service/request/server';

const baseApi = () => {
  function getCustomer(data) {
      return Post(`${envConfig.getCurrentApi()}/cotton/` + 'getCustomers', data);
  }

  return {
      getCustomer
  }
}

export const customerApi = baseApi()